module.exports = __webpack_public_path__ + "static/GT-Walsheim-Medium.dadd1609.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GT-Walsheim-Medium.woff
// module id = 141
// module chunks = 95715928098905 173670457132349